module.exports = __webpack_public_path__ + "static/media/trash.4150b484.svg";